import { extractErrorResponse } from './authErrorMapper';
import i18n from '~/i18n';

// Err here is an error object with code, and description
export default err => {
    if (
        err.code === 'DuplicateUserName' ||
        err.code === 'DuplicateEmail' ||
        err.code === 'EmailNotAvailable'
    ) {
        return i18n.t('errors.spotlightErrors.userUpdate.emailAlreadyInUse');
    }
    return i18n.t('errors.spotlightErrors.userUpdate.default');
};
